import { isEmptyObject } from "lib/utils";
import Api, { FIELDS_PARAM, FILTER_PARAM, LIMIT_PARAM } from "lib/api";
export const API_PATH = "/api/v1/employee";

class EmployeeApi {
  exist = (data) => {
    return !isEmptyObject(data) && data.id > 0;
  };

  /**
   * Restituisce le informazioni sul cliente
   * @param {*} id
   */
  get = async (id) => {
    try {
      return await Api.get(`${API_PATH}/${id}`);
    } catch (e) {
      return null;
    }
  };
  /**
   * Restituisce la lista dei clienti nel formato
   * utilizzabile per le select
   */
  search = async (q) => {
    let filters = [{ field: "q", value: q }];
    return await Api.get(API_PATH, {
      [FIELDS_PARAM]: "id,name,email,cost",
      [FILTER_PARAM]: JSON.stringify(filters),
      [LIMIT_PARAM]: 5,
    });
  };
  searchOptions = async (q) => {
    const result = await this.search(q);
    return result.items.map((r) => {
      return {
        value: r.id,
        label: r.name,
      };
    });
  };
  allActive = async () => {
    let filters = [{ field: "enabled", value: 1 }];
    return await Api.get(API_PATH, {
      [FIELDS_PARAM]: "id,name,email",
      [FILTER_PARAM]: JSON.stringify(filters),
      [LIMIT_PARAM]: 2000,
    });
  };

  allActiveOption = async () => {
    const result = await this.allActive();
    return result.items.map((r) => {
      return {
        value: r.id,
        label: r.name,
      };
    });
  };

  getEmployeeTimeSpent = async (from, to) => {
    return Api.get("/api/v1/employee/toolProject/time-spent", {
      from: from,
      to: to,
    });
  };

  loginEmployee = async (email, password) => {
    const result = await Api.post("/employee/connect/token", {
      email,
      password,
    });
    return result;
  };
}
const api = new EmployeeApi();
export default api;
